import { Box, Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useNavigate } from 'react-router-dom';

const ErrorPayment = () => {
  const { t } = useTranslation(['mobilityvoucher']);
  const navigate = useNavigate();
  const goToHome = () => {
    navigate('/mobilityvoucher/orders')
  }
  return (
    <>
      <Box
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
        alignItems={'center'}
        paddingTop={'110px'}
        paddingBottom={'230px'}
      >
        <HighlightOffIcon />
        <h4>{t("checkout.operationFailed")}</h4>
        <p>{t("checkout.operationFailedDetail")}</p>        
        <p></p>
        <Stack direction="row" spacing={2} alignItems={"center"}>
          <Button onClick={goToHome} variant="outlined" size='smallPlus'>
            {t("buttons.goHome")}
          </Button>
          {/* <Button variant="contained" size='smallPlus'>
            {t("buttons.tryAgain")}
          </Button> */}
        </Stack>
      </Box>
    </>
  );
};

export default ErrorPayment;